<template>
  <div class="order watchDetails" v-cloak>
    <appheader></appheader>
    <div class="box">
      <div>
        <div @mouseenter="stopImglunbo" @mouseleave="mouseLeave" class="magnifier-wrap">
          <svg-icon v-if="DataList.isPresell === '1'" iconClass="pre-sale-label" className="pre-sale-label"></svg-icon>
          <magnifier :src="imgurl"></magnifier>
        </div>
        <div class="banner">
          <div class="slide">
            <div :class="[index == 0 ? 'imgbck' : '', 'imgbox']" v-for="(item, index) in DataList.imgPathList" :key="index" @click="changeImg(index)">
              <img :src="item" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="introduction">
          <div class="productNameClass">{{ DataList.productName }}</div>
          <div>
            <div v-if="!isColleFlag" @click="colleBtn('收藏')" class="introduction cursor">
              <svg-icon iconClass="collection_default" className="collection_default"></svg-icon>收藏商品
            </div>
            <div v-if="isColleFlag" @click="colleBtn('取消')" class="introduction cursor">
              <svg-icon iconClass="collection_selected" className="collection_default"></svg-icon>已收藏
            </div>
          </div>
        </div>
        <div class="content-details">
          <div class="content-details-child">
            <div class="content-details-text" v-if="DataList.styleNumber">
              公司款号：{{ DataList.styleNumber }}<span class="copyText cursor" @click="seccendCopy">复制</span>
            </div>
            <div class="content-details-text" v-if="DataList.mechanicalType">类型：{{ DataList.mechanicalType }}</div>
            <div class="content-details-text" v-if="DataList.gender && DataList.isCouples == 2">款式：{{ DataList.gender }}</div>
            <div class="content-details-text" v-if="DataList.isCouples">情侣款：{{ DataList.isCouples == 2 ? '否' : '是' }}</div>
          </div>
          <div class="content-details-child">
            <div class="content-details-text" v-if="DataList.bandMaterial">表带材质：{{ DataList.bandMaterial }}</div>
            <div class="content-details-text" v-if="DataList.dialColor">表盘颜色：{{ DataList.dialColor }}</div>
            <div class="content-details-text" v-if="DataList.watchAssistStoneName">副宝石配石：{{ DataList.watchAssistStoneName }}</div>
          </div>
          <div class="content-details-child">
            <div
              class="content-details-text"
              v-if="DataList.wholesaleLaborCost && hasPriceViewPermission()"
            >
              批发克工费：{{ DataList.wholesaleLaborCost }}
            </div>
            <div
              class="content-details-text"
              v-if="DataList.tradePriceWatch && hasPriceViewPermission()"
            >
              表批发价：{{ Math.round(DataList.tradePriceWatch) }}
            </div>
          </div>
        </div>
        <!-- 单独款 -->
        <div class="box_goumai" v-if="DataList.isCouples === '2'">
          <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
            <el-tab-pane label="现货" name="first" :disabled="DataList.isPresell === '1'">
              <Spot
                v-if="DataList.stockQuantity > 0"
                @upDataStockQuantity="upDataStockQuantity"
                ref="spot"
                :DataList="DataList"
                :leastQuantity="DataList.leastQuantity"
              />
            </el-tab-pane>
            <el-tab-pane v-if="hasMainBodyType()[0].value !== '2'" disabled :label="DataList.isPresell === '1' ? '预售定单' : '定单'" name="second">
              <!-- <Custom @selectionCustom="selectionCustom" :leastQuantity="DataList.leastQuantity" ref="custom" :DataList="DataList" /> -->
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 情侣对戒 -->
        <div v-if="DataList.isCouples === '1'">
          <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
            <el-tab-pane label="现货" name="first" :disabled="DataList.isPresell === '1'">
              <LoversSpot v-if="DataList.stockQuantity > 0" :leastQuantity="DataList.leastQuantity" ref="loversSpot" :DataList="DataList" />
            </el-tab-pane>
            <el-tab-pane v-if="hasMainBodyType()[0].value !== '2'" disabled :label="DataList.isPresell === '1' ? '预售定单' : '定单'" name="second">
              <!-- <LoversCustom @selectionCustom="selectionCustom" :leastQuantity="DataList.leastQuantity" ref="loversCustom" :DataList="DataList" /> -->
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="subscribeToContainer" v-if="activeName === 'first' && DataList.stockQuantity == 0">
          <div class="subscribeTo" @click="updateSubscribe" v-if="!isSubscribe">
            <img src="../../Img/detaile/not-subscribe-to.png" alt="" /> 订阅到货通知
          </div>
          <div class="subscribeTo hasSubscribe" @click="updateSubscribe" v-if="isSubscribe">
            <img src="../../Img/detaile/has-subscribe-to.png" alt="" /> 已订阅到货通知
          </div>
        </div>
        <div class="addClass" v-if="(activeName === 'first' && DataList.stockQuantity > 0) || activeName === 'second'">
          <BeInterestedIn
            @interestedInUpdata="interestedInUpdata"
            :id="$route.query.id"
            :isLikeTwo="DataList.isLikeTwo"
            :isPresell="DataList.isPresell"
            :styleNumber="DataList.styleNumber"
          ></BeInterestedIn>
          <div class="onebottom">
            <div class="onebottom">
              <el-button @click="pushshopping('cart')" class="pushCart">加入购物车</el-button>
              <el-button @click="pushshopping('order')">立即购买</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 套系推荐 -->
    <MantleSystemRecommended :mantleSystemList="mantleSystemList" :codeType="$route.query.codeType"> </MantleSystemRecommended>
    <!-- 相似推荐 -->
    <SimilarRecommendation :recommendationList="recommendationList" :codeType="$route.query.codeType"> </SimilarRecommendation>
    <bottom></bottom>
    <SubmitDialog
      v-if="submitDialogVisible"
      :submitDialogVisible="submitDialogVisible"
      @onCloseSelectDialog="onCloseSelectDialog"
      @placeOrder="placeOrder"
    />
  </div>
</template>

<script>
import Magnifier from '../moudel/magnifier';
import $ from 'jquery';
import Appheader from '../moudel/Appheader';
import bottom from '../bady_bottom/bottom';
import { debounce } from '@/utils/index';
import { getDiamondInfo, addCollection, getSimilarity, getMantleSystem, whetherSubscribeTo, editSubscribeTo, messagePoint } from '@/api/detailsApi';
import { modifyCartPublic, pushOrder } from '@/api/cartApi';
import Spot from './components/Spot.vue';
import Custom from './components/Custom.vue';
import LoversSpot from './components/loversSpot.vue';
import LoversCustom from './components/LoversCustom.vue';
import BeInterestedIn from '../../components/BeInterestedIn.vue';
import SimilarRecommendation from '../../components/SimilarRecommendation.vue';
import MantleSystemRecommended from '../../components/MantleSystemRecommended.vue';
import SubmitDialog from '@/components/SubmitDialog.vue';
import ls from '@/utils/localStorage';
import { deepClone } from '@/utils/util';
export default {
  components: {
    Magnifier,
    Appheader,
    bottom,
    Spot,
    Custom,
    LoversSpot,
    LoversCustom,
    BeInterestedIn,
    SimilarRecommendation,
    MantleSystemRecommended,
    SubmitDialog,
  },
  data() {
    return {
      activeName: 'first',
      submitDialogVisible: false,
      DataList: {
        styleNumber: this.$route.query.styleNumber,
      },
      imgurl: '',
      index: 0, //开始轮播的值
      timer: null, //停止轮播的值
      size: 0, //图片的张数
      picHeight: 0, //图片的高度
      isColleFlag: false,
      recommendationList: [], //相似推荐
      mantleSystemList: [], //套系推荐
      isSubscribe: false,
      flag: false,
      placeOrderLoading: false,
      addCartOrder: {},
    };
  },
  destroyed() {
    ls.remove('coludQuery');
  },
  created() {
    // 获取商品详情
    this.getDiamondInfo();
    if (ls.get('coludQuery')) {
      // 埋点
      this.messagePoint('0');
    }
  },
  methods: {
    // 更新庫存
    upDataStockQuantity(stockQuantity) {
      // this.DataList.stockQuantity = stockQuantity;
    },
    // 关闭弹窗
    onCloseSelectDialog() {
      this.submitDialogVisible = false;
    },
    // 复制款号
    seccendCopy() {
      var that = this;
      this.$copyText(this.DataList.styleNumber).then(
        function (e) {
          that.$message({
            message: '复制成功!',
            type: 'success',
            duration: 1500,
          });
        },
        function (e) {
          that.$message({
            message: '复制失败!',
            type: 'warning',
            duration: 1500,
          });
        },
      );
    },
    messagePoint(pointType) {
      const query = {
        styleNumber: this.$route.query.styleNumber,
        pointType: pointType,
      };
      messagePoint(query).then((res) => {});
    },
    // 点击感兴趣刷新页面
    interestedInUpdata() {
      this.getDiamondInfo();
    },
    // 相似推荐
    getRecommendation(styleNumber) {
      //相似推荐
      getSimilarity(styleNumber).then((res) => {
        this.recommendationList = res.data.records || [];
      });
      //套系推荐
      getMantleSystem(styleNumber).then((res) => {
        this.mantleSystemList = res.data.records || [];
      });
    },
    // 订阅-取消订阅
    updateSubscribe() {
      let obj = {
        styleNumber: this.DataList.styleNumber,
        columnCode: this.$route.query.codeType,
        requestFrom: 2,
      };
      if (!this.flag) {
        this.flag = true;
        editSubscribeTo(obj).then((res) => {
          this.isSubscribe = !this.isSubscribe;
          this.$message({
            message: '修改成功',
            type: 'success',
            duration: 1000,
          });
          this.flag = false;
        });
      }
    },
    // 查询是否订阅
    whetherSubscribeTo(styleNumber) {
      let obj = {
        styleNumber: styleNumber,
        columnCode: this.$route.query.codeType,
      };
      whetherSubscribeTo(obj).then((res) => {
        this.isSubscribe = res.data;
      });
    },
    // 点击切换定制现货情况选择数量状态
    handleClick(tab, event) {
      this.isStyleShape();
    },
    // 加入购物车
    pushshopping: debounce(
      function (type) {
        this.addCartOrder = {
          productDtoList: [],
          orderNowDtoList: [],
          shopType: 3,
          type: 1,
          isCouples: this.DataList.isCouples,
          orderPath: 1,
          spotFlag: 1,
          requestFrom: 1,
          purchaseSource: ls.get('coludQuery') ? 0 : 1, //0 云平台产品推荐, 1 其他渠道"
          siteId: ls.get('siteId') || ls.get('userInfo').sysUser?.siteId || '',
        };
        if (this.DataList.isCouples === '1') {
          if (this.activeName === 'first') {
            if (this.$refs.loversSpot.dataFrom.quantity > 0) {
              this.addCartOrder.productDtoList.push(this.$refs.loversSpot.dataFrom);
              if (!this.$refs.loversSpot.dataFrom.bandColor || !this.$refs.loversSpot.dataFrom.goldWeigh) {
                return this.$message({
                  message: '请选择参数',
                  type: 'warning',
                  duration: 1500,
                });
              }
            }
            if (this.$refs.loversSpot.maleDataFrom.quantity > 0) {
              this.addCartOrder.productDtoList.push(this.$refs.loversSpot.maleDataFrom);
              if (!this.$refs.loversSpot.maleDataFrom.bandColor || !this.$refs.loversSpot.maleDataFrom.goldWeigh) {
                return this.$message({
                  message: '请选择参数',
                  type: 'warning',
                  duration: 1500,
                });
              }
            }
          } else {
            this.addCartOrder.type = 2;
            this.addCartOrder.spotFlag = 2;
            this.addCartOrder.productDtoList.push(this.$refs.loversCustom.dataFrom);
          }
        } else {
          // first现货 second定单
          if (this.activeName === 'first') {
            this.addCartOrder.productDtoList.push(this.$refs.spot.dataFrom);
            if (!this.$refs.spot.dataFrom.bandColor || !this.$refs.spot.dataFrom.goldWeigh) {
              return this.$message({
                message: '请选择参数',
                type: 'warning',
                duration: 1500,
              });
            }
          } else {
            this.addCartOrder.type = 2;
            this.addCartOrder.spotFlag = 2;
            this.addCartOrder.productDtoList.push(this.$refs.custom.dataFrom);
          }
        }
        if (type == 'cart') {
          modifyCartPublic(this.addCartOrder, 'post').then((res) => {
            if (res.code == 0) {
              this.$confirm('添加成功', '提示', {
                confirmButtonText: '去购物车',
                cancelButtonText: '继续添加',
                type: 'success',
              })
                .then(() => {
                  this.$router.push('/shoppingCart');
                })
                .catch(() => {
                  // 加完购物车刷新现货列表
                });
            }
          });
        } else {
          this.addCartOrder.orderPath = 2;
          this.addCartOrder.orderNowDtoList = deepClone(this.addCartOrder.productDtoList);
          this.submitDialogVisible = true;
        }
      },
      500,
      true,
    ),
    // 确定下单
    placeOrder(from) {
      if (this.placeOrderLoading) return;

      this.placeOrderLoading = true;
      const loadingInstance = this.$loading({
        lock: true,
        text: '正在提交订单',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)',
      });
      let orderInfor = deepClone(from);
      delete orderInfor.organizationList;
      // 修改bug
      if (orderInfor.netAddress?.indexOf('-') > 0) {
        orderInfor.netCode = from.netAddress.split('-')[0];
        orderInfor.netAddress = from.netAddress.split('-')[1];
      } else {
        orderInfor.netCode = '';
        orderInfor.netAddress = '';
      }
      this.addCartOrder = { ...this.addCartOrder, ...orderInfor };
      delete this.addCartOrder.productDtoList;
      pushOrder(this.addCartOrder)
        .then((res) => {
          if (res.code === 0) {
            this.submitDialogVisible = false;
            this.$confirm('提交成功', '提示', {
              confirmButtonText: '继续下单',
              cancelButtonText: '查看订单',
              type: 'success',
            })
              .then(() => {})
              .catch(async () => {
                if (this.$route.query.groupFlag == 1) {
                  this.$router.push('/PresellOrder');
                } else {
                  const isFactoryUser = await this.isFactory().catch(() => false);
                  if (isFactoryUser) {
                    this.$router.push({ path: '/RviewOrder' });
                  } else this.$router.push({ path: '/CommodityOrder' });
                }
              });
          }
        })
        .catch((err) => {
          if (err === '存在已售或下架商品') {
            this.submitDialogVisible = false;
          }
        })
        .finally(() => {
          this.placeOrderLoading = false;
          loadingInstance.close();
        });
    },
    // 鼠标移出开始轮播
    mouseLeave() {
      this.autoSlide(); // 图片开始再次轮播
    },
    // 清除定时器
    stopImglunbo() {
      clearInterval(this.timer);
    },
    // 点击收藏
    colleBtn(text) {
      let obj = {
        id: this.$route.query.styleNumber,
        isLike: text === '收藏' ? 1 : 0,
      };
      addCollection(obj).then((res) => {
        text === '收藏' ? (this.isColleFlag = true) : (this.isColleFlag = false);
        this.$message({
          message: res.data,
          type: 'success',
          duration: 1500,
        });
      });
    },
    // 足迹新增
    footMark() {
      var that = this;
      var url = '/footMark/save';
      var data = {
        styleNumber: this.DataList.styleNumber,
        serialNumber: this.$route.query.serialNumber,
        imgUrl: this.DataList.imgPathList[0],
        shopType: 3,
        title: this.DataList.productName,
        type: this.$route.query.type,
        buyerId: JSON.parse(localStorage.getItem('userData')).userCode,
      };
      that
        .$axios({
          url: url,
          method: 'post',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
          },
          data: JSON.stringify(data),
        })
        .then((re) => {});
    },
    // 判断是不是汝瓷、木雕
    isStyleShape() {
      if (this.DataList.styleShape && (this.DataList.styleShape == '汝瓷' || this.DataList.styleShape == '木雕') && this.activeName == 'second') {
        this.$alert('本款工艺特殊，定制前请与生产管理部确认起订件数，确认后再提交订单，感谢配合！', '温馨提示', {
          confirmButtonText: '确定',
          callback: (action) => {},
        });
      }
    },
    //获取商品详情
    getDiamondInfo() {
      const query = {
        styleNumber: this.$route.query.styleNumber,
        classify: this.$route.query.classify,
      };
      getDiamondInfo(query).then((res) => {
        this.DataList = res.data;
        //isCouples 1是情侣款 2 否
        //isPresell 1是预收款 2 否
        //isLike 0是未收藏  2是已收藏
        //isLikeTwo 0是未感兴趣  1是感兴趣
        if (this.DataList.isLike === '0') {
          this.isColleFlag = false;
        } else {
          this.isColleFlag = true;
        }
        this.imgurl = res.data.imgPathList[0];
        if (res.data.imgPathList.length > 3) {
          this.DataList.imgPathList = res.data.imgPathList.splice(0, 3);
        } else {
          this.DataList.imgPathList = res.data.imgPathList;
        }
        this.isStyleShape();
        // 相识推荐-套系
        this.getRecommendation(this.DataList.styleNumber);
        // 是否订阅
        this.whetherSubscribeTo(this.DataList.styleNumber);
        // DOM 渲染完毕后执行轮播事件
        this.$nextTick(function () {
          this.picHeight = $('.slide img').width(); //获取宽度度
          this.size = $('.slide').children().length; // 获取图片张数
          this.autoSlide(); // 图片开始再次轮播
          $('.banner').mouseover(() => {
            clearInterval(this.timer); // 停止图片轮播
          });
          $('.banner').mouseleave(() => {
            this.autoSlide(); // 图片开始再次轮播
          });
          // $('.slide').mouseleave();
        });
      });
    },
    autoSlide() {
      // 图片轮播函数
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        let l = this.DataList.imgPathList.length;
        // debugger
        if (this.index < l) {
          $('.imgbox').removeClass('imgbck');
          $('.imgbox').eq(this.index).addClass('imgbck');
          this.imgurl = this.DataList.imgPathList[this.index];
          this.index++;
        } else {
          $('.imgbox').removeClass('imgbck');
          $('.imgbox').eq(0).addClass('imgbck');
          this.imgurl = this.DataList.imgPathList[0];
          this.index = 1;
        }
        // this.changeDots();
      }, 3000); //每隔1.5S就切换一次图片
    },
    changeImg(index) {
      $('.imgbox').removeClass('imgbck');
      $('.imgbox').eq(index).addClass('imgbck');
      this.imgurl = this.DataList.imgPathList[index];
      this.index = index;
    },
  },
  // 离开页面清除定时器
  beforeDestroy() {
    clearInterval(this.timer);
  },
  beforeRouteLeave(to, from, next) {
    // 从列表页去到别的页面，如果不是详情页，则不缓存列表页
    if (to.name != 'home') {
      this.$route.meta.keepAlive = false;
      this.$route.meta.flag = false;
    } else if (to.name == 'home') {
      this.$route.meta.keepAlive = true;
      this.$route.meta.flag = true;
    }
    next();
  },
};
</script>

<style scoped lang="scss">
.watchDetails {
  .content-box {
    width: 800px;
  }

  .introduction {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .cursor {
    cursor: pointer;
  }

  .productNameClass {
    font-size: 24px;
    color: #ec9368;
  }
  .content-details {
    display: flex;
    margin: 10px 0;
    .content-details-child {
      .content-details-text {
        padding: 0 30px 14px 0;
      }
      .copyText {
        color: #ec9368;
        margin-left: 10px;
      }
    }
  }
}
</style>
